"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonStringify = jsonStringify;
exports.jsonParse = jsonParse;
exports.tryStringify = tryStringify;
exports.tryConvertDates = tryConvertDates;
const fast_safe_stringify_1 = __importDefault(require("fast-safe-stringify"));
const bigintRegex = /^bigint\((-?[\d]*)\)$/;
const buffer64Regex = /^buffer64\(-?([\d]*)\)$/;
function bigIntReplacer(_key, value) {
    if (typeof value === 'bigint') {
        return `bigint(${value.toString()})`;
    }
    return value;
}
function bigIntAndDateAndBufferReviver(key, value) {
    if (typeof value === 'string') {
        const bigIntMatch = bigintRegex.exec(value);
        if (bigIntMatch) {
            return BigInt(bigIntMatch[1]);
        }
        const bufferMatch = buffer64Regex.exec(value);
        if (bufferMatch) {
            return base64ToUint8Array(bufferMatch[1]);
        }
        if (key.endsWith('At') || key.endsWith('Date')) {
            return new Date(value);
        }
    }
    return value;
}
function base64ToUint8Array(base64) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(base64, 'base64');
    }
    else {
        return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    }
}
function jsonStringify(o, space) {
    // TODO: Use fastSafeStringify instead?
    return JSON.stringify(o, bigIntReplacer, space);
}
function jsonParse(s) {
    return JSON.parse(s, bigIntAndDateAndBufferReviver);
}
function tryStringify(o) {
    try {
        return typeof o === 'string' ? o : (0, fast_safe_stringify_1.default)(o);
    }
    catch {
        // E.g. due circular dependencies
        return undefined;
    }
}
const isISOString = (s) => {
    return typeof s === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/.test(s);
};
/**  Covert ISOString to Date recursively */
function tryConvertDates(item) {
    if (!item)
        return item;
    if (Array.isArray(item)) {
        return item.map(tryConvertDates);
    }
    else if (typeof item === 'object') {
        for (const key of Object.keys(item)) {
            item[key] = tryConvertDates(item[key]);
        }
        return item;
    }
    else if (isISOString(item)) {
        return item.endsWith('Z') ? new Date(item) : new Date(item + '.000Z');
    }
    else {
        return item;
    }
}
//# sourceMappingURL=data:application/json;base64,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